import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'thankYou', Record<UrlRegion, UrlEntry>> = {
  thankYou: {
    de: 'danke',
    'de-en': 'thank-you',
    es: 'gracias',
    'es-en': 'thank-you',
    fr: 'merci',
    'fr-en': 'thank-you',
    gb: 'thank-you',
    nl: 'bedankt',
    'nl-en': 'thank-you',
    pt: 'obrigado',
    'pt-en': 'thank-you',
    us: 'thank-you',
    ww: 'thank-you',
  },
};
